module.exports = __webpack_public_path__ + "img/ins.4cc2dcb5.svg";